import InfoImageController from "./InfoImageController";
import InfoImageUI from "./InfoImageUI";
import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import "./styles.css";

export default class InfoImage extends Plugin {
    static get requires() {
        return [ InfoImageController, InfoImageUI ];
    }
}